import { useCallback, useEffect, useState } from 'react';
import {
	Dialog,
	DialogTrigger,
	DialogContent,
	DialogHeader,
	DialogTitle,
	DialogFooter,
} from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { useSelector } from 'react-redux';

import { CustomButton } from '@/components/ui/custom/CustomButton';
import { useDispatch } from 'react-redux';
import { addFolder } from '@/actions/folders';

const CreateFolderDialog = ({ open, setOpen, children }) => {
	const [newTitle, setNewTitle] = useState('');
	const folders = useSelector((state) => state.folders);
	const [error, setError] = useState('');

	const dispatch = useDispatch();

	const closeDialog = useCallback(() => {
		setError(false);
		setNewTitle('');
		setOpen(false);
	}, [setOpen]);

	const createFolder = useCallback(async () => {
		if (!newTitle) {
			setError('Please enter a folder name');
			return;
		}

		if (folders.find((folder) => folder.title === newTitle)) {
			setError('A folder with the name ' + newTitle + ' already exists');
			return;
		}

		dispatch(addFolder({ folderTitle: newTitle }));
		closeDialog();
	}, [closeDialog, dispatch, folders, newTitle]);

	useEffect(() => {
		if (!open) return undefined;

		const handleKeyDown = (e) => {
			if (e.key === 'Enter') {
				createFolder();
			}
		};

		document.addEventListener('keydown', handleKeyDown);
		return () => {
			document.removeEventListener('keydown', handleKeyDown);
		};
	}, [createFolder, open]);

	return (
		<Dialog open={open} onOpenChange={setOpen}>
			{children && <DialogTrigger asChild>{children}</DialogTrigger>}
			<DialogContent>
				<DialogHeader>
					<DialogTitle>Create a folder</DialogTitle>
				</DialogHeader>
				<Input
					placeholder="Folder Name"
					aria-label="Folder name"
					autoComplete="off"
					enterKeyHint="done"
					value={newTitle}
					onChange={(e) => setNewTitle(e.target.value)} // Corrected
				/>
				{error && <p className="text-sm text-destructive">{error}</p>}
				<DialogFooter>
					<CustomButton variant="ghost" onClick={closeDialog}>
						Cancel
					</CustomButton>
					<CustomButton variant="default" onClick={createFolder}>
						Save
					</CustomButton>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	);
};

export default CreateFolderDialog;
